"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useTracking } from "react-tracking";
import { Text } from "@nxt-costco-com/forge-components";
import { CostcoBox } from "../../Util/CostcoBox.js";
import GenericImageHandler from "../../Util/GenericImageHandler.js";
import { VIEW_NAME_FEATURES } from "./constants.js";
import { StyledTileContainer, StyledLinkContainer, StyledBodyContainer, StyledTitleContainer, StyledFeatureContainer, StyledShopNowContainer, StyledShopNowButton, StyledHeaderContainer, StylesIconContainer, HEADER_ICON_HEIGHT, StyledFeatureGroup, StyledFeatureImage } from "./styles.js";
const CardHeader = ({ data }) => {
  var _a, _b, _c, _d, _e;
  if (!data) {
    return null;
  }
  const headerImage = (_b = (_a = data.image_group) == null ? void 0 : _a.image) == null ? void 0 : _b[0];
  const headerIcon = (_d = (_c = data.image_group) == null ? void 0 : _c.overlay_icon) == null ? void 0 : _d[0];
  return /* @__PURE__ */ jsx(
    StyledHeaderContainer,
    {
      style: {
        backgroundImage: `url(${headerImage == null ? void 0 : headerImage.url})`
      },
      children: /* @__PURE__ */ jsx(StylesIconContainer, { children: /* @__PURE__ */ jsx(
        GenericImageHandler,
        {
          alt: ((_e = data.image_group) == null ? void 0 : _e.feature_image_alt_text) || "",
          className: "overlay-icon",
          loading: "lazy",
          src: headerIcon == null ? void 0 : headerIcon.url,
          sx: { width: HEADER_ICON_HEIGHT }
        }
      ) })
    }
  );
};
const FeatureGroup = ({
  iconGroup,
  index
}) => {
  var _a, _b, _c, _d, _e;
  return /* @__PURE__ */ jsxs(StyledFeatureGroup, { children: [
    /* @__PURE__ */ jsx(
      StyledFeatureImage,
      {
        sx: {
          transitionDelay: `0.${index + 1}s`
        },
        alt: "",
        loading: "lazy",
        src: (_c = (_b = (_a = iconGroup.feature_icon_block) == null ? void 0 : _a.icon_image) == null ? void 0 : _b[0]) == null ? void 0 : _c.url
      }
    ),
    /* @__PURE__ */ jsx(CostcoBox, { className: "feature-text", children: (_e = (_d = iconGroup.feature_icon_block) == null ? void 0 : _d.text_and_costco_url) == null ? void 0 : _e.title })
  ] });
};
function FeaturesCard({ data }) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const { trackEvent } = useTracking();
  const onClickHandler = () => {
    trackEvent();
  };
  if (!data) {
    return null;
  }
  const { button_group, feature_icon_group: featureGroups } = data;
  const shopNowButton = button_group;
  const disableThirdPartyTracking = (_a = data == null ? void 0 : data.privacy_toggle) == null ? void 0 : _a.disable_third_party_tracking;
  return /* @__PURE__ */ jsx(StyledTileContainer, { "data-testid": VIEW_NAME_FEATURES, children: /* @__PURE__ */ jsxs(
    StyledLinkContainer,
    {
      sx: {
        background: (_c = (_b = data.card_styling) == null ? void 0 : _b.card_background_color) == null ? void 0 : _c.hex,
        color: `${(_e = (_d = data.card_styling) == null ? void 0 : _d.card_font_color) == null ? void 0 : _e.hex} !important`
      },
      href: (_f = shopNowButton == null ? void 0 : shopNowButton.button_with_costco_url) == null ? void 0 : _f.url,
      onClick: onClickHandler,
      ...disableThirdPartyTracking && { "data-private": "" },
      children: [
        /* @__PURE__ */ jsx(CardHeader, { data }),
        /* @__PURE__ */ jsxs(StyledBodyContainer, { children: [
          /* @__PURE__ */ jsx(StyledTitleContainer, { children: /* @__PURE__ */ jsx(
            Text,
            {
              sx: {
                color: (_h = (_g = data.card_styling) == null ? void 0 : _g.card_font_color) == null ? void 0 : _h.hex
              },
              component: "h2",
              children: data.feature_title
            }
          ) }),
          /* @__PURE__ */ jsx(StyledFeatureContainer, { children: featureGroups == null ? void 0 : featureGroups.map((iconGroup, i) => /* @__PURE__ */ jsx(
            FeatureGroup,
            {
              iconGroup,
              index: i
            },
            i
          )) }),
          /* @__PURE__ */ jsx(StyledShopNowContainer, { children: /* @__PURE__ */ jsx(
            StyledShopNowButton,
            {
              sx: {
                background: (_i = shopNowButton == null ? void 0 : shopNowButton.button_background_color) == null ? void 0 : _i.hex,
                color: (_j = shopNowButton == null ? void 0 : shopNowButton.button_text_color) == null ? void 0 : _j.hex
              },
              children: (_k = shopNowButton == null ? void 0 : shopNowButton.button_with_costco_url) == null ? void 0 : _k.title
            }
          ) })
        ] })
      ]
    }
  ) });
}
export {
  FeaturesCard
};
